import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { SelfAverageFocusScoreEntity } from '../../../core/domain/entities/scores/self-average-focus-score.entity';

export interface ISelfAverageFocusScorePersistenceResponse {
  [IWorkingSessionsAnalyticsActivityEnum.TotalFocusDuration]: string;
  [IWorkingSessionsAnalyticsActivityEnum.TotalDuration]: string;
}

export class SelfAverageFocusScoreMapper
  implements Omit<Mapper<SelfAverageFocusScoreEntity, any>, 'toResponse'>
{
  toDomain(
    record: ISelfAverageFocusScorePersistenceResponse
  ): SelfAverageFocusScoreEntity {
    return SelfAverageFocusScoreMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfAverageFocusScorePersistenceResponse
  ): SelfAverageFocusScoreEntity {
    const entity = SelfAverageFocusScoreEntity.create({
      totalDuration: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalDuration]
      ),
      totalFocusDuration: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalFocusDuration]
      ),
    });
    return entity;
  }
}
